import { both, compose, flip, juxt, keys, map, pickBy, prop } from 'ramda';
import { isIn, isNotIn } from './conditions';
/*
 * this function does 2 things
 * 1. if the props keys e.g. {"red": true}, if the key "red" matches the CSS modules object. eg. { red: 'componentName---red___1zx2x3v123ospo14' }
 * then if the keys value is not falsy then pick it to first Array ( ignore keys with falsy values ).
 *
 * 2. if the prop keys is not matching the CSS modules object keys then pick it to second Array.
 *
 * */
// TODO: figure out return type
export default (props, styles) => {
    return juxt([
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        compose(map(flip(prop)(styles)), keys, pickBy(both((css) => !!css, isIn(styles)))),
        pickBy(isNotIn(styles)),
    ])(props);
};
//# sourceMappingURL=getVariationsFromProps.js.map